import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001; /* Z-index maior para ficar sobre o outro modal, se necessário */
  animation: ${fadeIn} 0.3s ease-out;
`;

export const ModalBox = styled.div`
  position: relative;
  background-color: #121212; // Fundo escuro para combinar com o tema
  border-radius: 16px;
  padding: 2rem;
  max-width: 95%;
  max-height: 90vh;
  width: 1200px; /* Largura para caber 3 cards lado a lado */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  @media (max-width: 1250px) {
    width: 850px; /* Largura para caber 2 cards */
  }
   @media (max-width: 900px) {
    width: 90%; /* Ajuste para telas menores */
    max-width: 450px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  color: #A9A9AA;
  font-size: 1.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    color: #FFFFFF;
    transform: scale(1.1);
  }
`;

export const ScrollableContent = styled.div`
  overflow-y: auto;
  padding-right: 1rem; // Espaço para a barra de rolagem

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #1E1E1E;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #D4AF37;
    border-radius: 4px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-bottom: 2rem;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  color: white;
  margin: 0;
`;

export const SubTitle = styled.p`
  font-size: 1.6rem;
  font-weight: 400;
  color: #A9A9A9;
  margin: 0;
`;

export const BoxesContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
`;

export const Box = styled.div`
  width: 350px;
  background: #1E1E1E;
  border-radius: 12px;
  border: 1px solid #333333;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(212, 175, 55, 0.15);
    border-color: #D4AF37;
  }
`;

export const BoxContent = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-grow: 1;
`;

export const BankTitle = styled.h3`
  text-align: center;
  font-size: 1.3rem;
  font-weight: 600;
  color: #D4AF37;
  margin: 0 0 0.5rem 0;
`;

export const InfoSection = styled.div`
  text-align: center;
`;

export const InfoLabel = styled.p`
  font-size: 1rem;
  color: #A9A9A9;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
`;

export const InfoValue = styled.p`
  font-size: 1.1rem;
  color: #FFFFFF;
  font-weight: 400;
  margin: 0;
`;

export const PixInfo = styled(InfoValue)`
  font-weight: 600;
  color: #EACD65;
`;

export const CopyButton = styled.button`
  width: 100%;
  padding: 1rem;
  border: none;
  background: #D4AF37;
  color: #1E1E1E;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    background: #EACD65;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const StateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 4rem 1rem;
  min-height: 200px;
`;

export const Spinner = styled.div`
  border: 4px solid rgba(212, 175, 55, 0.2);
  border-top: 4px solid #D4AF37;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: ${spin} 1s linear infinite;
`;

export const StateMessage = styled.p`
  color: #A9A9A9;
  font-size: 1.1rem;
  text-align: center;
  margin: 0;
`;